import { jsx as _jsx } from "react/jsx-runtime";
import icon from './return.svg';
export const ReturnSvgComponent = ({ onClick }) => {
    return (_jsx("svg", { width: '10', height: '16', viewBox: '0 0 10 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, children: _jsx("path", { d: 'M9.08984 13.8827L3.17984 7.97266L9.08984 2.06266L7.49984 0.472656L-0.000156701 7.97266L7.49984 15.4727L9.08984 13.8827Z', fill: '#828282' }) }));
};
export default icon;
